import * as Types from '../mutation-types'
// import { LS } from '@utils/util'
const base = {
  state: {
    user: JSON.parse(localStorage.getItem('userData')) || null, // 用户信息
    token: localStorage.getItem('YL_TOKEN') || ''
  },
  mutations: {
    // 用户信息
    [Types.SET_USER]: (state, data) => {
      state.user = data
      localStorage.setItem('userData', JSON.stringify(data))
    },
    // 用户token
    [Types.SET_TOKEN]: (state, data) => {
      state.token = data
      localStorage.setItem('YL_TOKEN', data)
    },
    // 退出
    [Types.LOGIN_OUT]: state => {
      // 退出登录，清楚本地缓存
      localStorage.removeItem('userData')
      localStorage.removeItem('YL_TOKEN')
      state.token = ''
      state.user = {}
    }
  },
  actions: {
    // 登录初始化
    [Types.LOGIN_INIT]({ commit } = {}, value) {
      const { user, token, systemMenus } = value
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      commit('SET_SYSTEM_MENU', systemMenus)
    },
    [Types.SET_TOKEN]({ commit } = {}, value) {
      console.log(' SET_TOKEN  value:>> ', value)
      commit('SET_TOKEN', value)
    },
    async [Types.LOGIN_OUT]({ commit } = {}, value) {
      commit('LOGIN_OUT', value || {})
    },
    [Types.SET_USER]({ commit } = {}, user) {
      commit('SET_USER', user || {})
      commit('SET_TOKEN', user.token)
    }
  },
  getters: {
    selectedId: state => state.selectedId,
    lang: state => state.lang,
    user: state => state.user,
    token: state => state.token || ''
  }
}

export default base
